import React from "react"
import { IB64File } from "../../../../types/IB64File"
import { IMG } from "../../CONST"
import { IFileItem } from "../../../../types/IFileItem"
import { download, round2Digits } from "../../CommonHelper"

export const CommonFileList: React.FC<{
  files?: IB64File[] | undefined
  file?: IB64File | undefined
  downloadableFiles?: IFileItem[] | undefined
  type?: string
}> = ({ files, file, downloadableFiles, type }) => {
  if ((files && files.length > 0) || file) {
    return (
      <ul className="file-list">
        <h5 className="file-heading">Прикрепленные файлы</h5>
        {files && files?.length > 0 ? (
          files.map((f, index) => (
            <li className="file-item" key={index}>
              <div className="flex-row-10">
                <img src={IMG.download} alt="" className="file-info" />
                {f.name} ({round2Digits(((f.b64?.length || 0) * (3 / 4) - 2) / 1024)} Кб.)
              </div>
            </li>
          ))
        ) : file ? (
          <li className="file-item">
            <div className="flex-row-10">
              <img src={IMG.download} alt="" className="file-info" />
              {file.name} ({round2Digits(((file.b64?.length || 0) * (3 / 4) - 2) / 1024)} Кб.)
            </div>
          </li>
        ) : (
          <></>
        )}
      </ul>
    )
  } else if (downloadableFiles && downloadableFiles.length > 0) {
    return (
      <ul className="file-list">
        <h5 className="file-heading">Загруженные файлы</h5>
        {downloadableFiles && downloadableFiles?.length > 0 ? (
          downloadableFiles.map((f, index) => (
            <li
              className="file-item"
              key={index}
              style={{ cursor: "pointer" }}
              onClick={() => download(f.id, type || "PAYMENT_ORDER")}
            >
              <div className="flex-row-10">
                <img src={IMG.download} alt="" className="file-info" />
                {`${index + 1}_${f.type}`}
              </div>
            </li>
          ))
        ) : (
          <></>
        )}
      </ul>
    )
  } else {
    return <></>
  }
}
